export default __webpack_public_path__ + "static/media/login2.46f5ac03.png";